import { dbDisplayName, lookupDatabaseAlias } from '@/common/domain/utils/dbDisplayName';

type DatabaseAliasCatalogRow = {
  name?: string | null;
  alias?: string | null;
};

/**
 * Turns a tool-access scope label into the same alias-or-name text the database filter shows.
 * "All databases" stays unchanged. A named scope is display-only and is never sent back as an identifier.
 */
export function operatorScopeDisplayLabel(
  scopeLabel: string | undefined,
  databaseNames: readonly string[],
  allDatabases: boolean,
  catalog: ReadonlyArray<DatabaseAliasCatalogRow>
): string | undefined {
  if (scopeLabel == null || scopeLabel.trim() === '') {
    return scopeLabel;
  }

  if (allDatabases || databaseNames.length === 0) {
    return scopeLabel;
  }

  const labels = databaseNames
    .map((name) => name.trim())
    .filter((name) => name !== '')
    .map((name) => dbDisplayName({ tenantDatabaseName: name, databaseAlias: lookupDatabaseAlias(name, catalog) }));

  if (labels.length === 0) {
    return scopeLabel;
  }

  return [...labels].sort((left, right) => left.localeCompare(right, undefined, { sensitivity: 'base' })).join(', ');
}
